import { AppBar, Button, CssBaseline, Drawer, makeStyles, Toolbar, Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import React, { useEffect, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { requestContracts, requestSkills } from "../../redux/manageLabourer/manageLabourerActions";
import { requestTechnicians } from "../../redux/technician/technicianActions";
import Help from "../header/headerActions/help";
import Profile from "../header/headerActions/profile";
import Settings from "../header/headerActions/settings";
import MainHeader from "../header/mainHeader";
import Search from "../common/search/search";
import ManageLabourerSidebar from "./manageLabourersSidebar";
import ManageLabourersPaper from "./manageLabourersPaper";
import LabourerDrawerForm from "./manageLabourerDrawer/labourerDrawerForm";

const drawerWidth = 200;
const headerHeight = 56;

const messages = defineMessages({
    labourerSettingsPageTitle: {
        id: "labourer-settings.title",
        defaultMessage: "Manage Labourers",
        description: "Labourer Settings page title",
    },
    labourerSettingsPageSearchPlaceholder: {
        id: "labourer-settings.search-placeholder",
        defaultMessage: "Search labourers",
        description: "Labourer Settings page search placeholder",
    },
    labourerCreateButton: {
        id: "labourer-settings.create-labourer-caption",
        defaultMessage: "Create user",
        description: "Labourer create button caption",
    },
});

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        height: "100%",
        backgroundColor: "#f4f4f4",
    },
    appBar: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        marginTop: headerHeight,
        backgroundColor: "white",
        color: "#555555",
        boxShadow: "none",
    },
    labourerSettingsPageTitle: {
        fontFamily: "BellSlimBlack",
        fontWeight: "900",
        fontSize: 18,
        lineHeight: "22px",
        letterSpacing: "-0.558px",
        color: "#111111",
        margin: "10px 0px",
    },
    drawer: {
        width: drawerWidth,
        marginTop: headerHeight,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        marginTop: headerHeight,
        backgroundColor: "#f4f4f4",
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
        marginLeft: drawerWidth,
        marginTop: headerHeight,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
        backgroundColor: "#f4f4f4",
    },
    button: {
        marginLeft: theme.spacing(1),
        color: "#00549A",
        fontSize: 16,
        fontFamily: "Arial",
        lineHeight: "21px",
        border: "1px solid #00549A",
        boxRadius: 4,
        width: 150,
    },
    searchbar: {
        marginLeft: "auto",
    },
}));

function ManageLabourer(props) {
    const classes = useStyles();
    const intl = useIntl();
    const [technicians, setTechnicians] = useState([]);
    const [filteredTechnicians, setFilteredTechnicians] = useState([]);
    const [createTechnician, setCreateTechnicianForm] = useState({
        open: false,
        data: "",
        create: false,
    });

    useEffect(() => {
        props.requestTechnicians();
        props.requestContracts();
        props.requestSkills();
    }, []);

    useEffect(() => {
        setTechnicians(props.technicians);
    }, [props.technicians]);

    useEffect(() => {
        setTechnicians(filteredTechnicians);
    }, [filteredTechnicians]);

    const handleSearch = (value) => {
        let tech = [];
        if (props.technicians && value !== "") {
            tech = props.technicians.filter(
                (tech) => tech.firstName.toLowerCase().includes(value.toLowerCase()) || tech.lastName.toLowerCase().includes(value.toLowerCase()),
            );
            setTechnicians(tech);
        } else if (props.technicians) {
            setTechnicians(props.technicians);
        }
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar position="fixed">
                <MainHeader subtitle="CMIS" actions={[<Help />, <Settings />, <Profile />]} />
            </AppBar>
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <Typography className={classes.labourerSettingsPageTitle}>{intl.formatMessage(messages.labourerSettingsPageTitle)}</Typography>
                    <Button
                        variant="outlined"
                        className={classes.button}
                        startIcon={<AddIcon />}
                        onClick={(event) => setCreateTechnicianForm({ open: true, data: "", create: true })}>
                        {intl.formatMessage(messages.labourerCreateButton)}
                    </Button>
                    <div className={classes.searchbar}>
                        <Search
                            placeholder={intl.formatMessage(messages.labourerSettingsPageSearchPlaceholder)}
                            onSearch={(val) => handleSearch(val)}></Search>
                    </div>
                </Toolbar>
            </AppBar>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                <ManageLabourersPaper {...props} technicians={technicians} />
            </main>
            <Drawer className={classes.drawer} variant="permanent" classes={{ paper: classes.drawerPaper }} anchor="left">
                <ManageLabourerSidebar
                    technicians={props.technicians}
                    contracts={props.contracts}
                    skills={props.skills}
                    handleFilteredTechnicians={(technicians) => setFilteredTechnicians(technicians)}
                />
            </Drawer>
            <LabourerDrawerForm
                state={createTechnician}
                showFooter={!createTechnician.open}
                closeform={(close) => setCreateTechnicianForm({ open: close, data: "", create: close })}
                {...props}
            />
        </div>
    );
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            requestTechnicians,
            requestContracts,
            requestSkills,
        },
        dispatch,
    );
const mapStateToProps = (state) => {
    return {
        technicians: state.technicians,
        contracts: state.contracts,
        skills: state.skills,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageLabourer);
